import React from 'react';
import Modal from 'react-responsive-modal';


class SelectMerchantsModal extends React.Component {

	plain = null;

	constructor(props) {
		super(props);
		this.plain = props.plain;
		this.state = {listMerchantInfo: [], dirtyCounter: 0};
	}
	init = (listMerchant) => {
		let listMerchantInfo = [];
		for( let m of listMerchant ) {
			listMerchantInfo.push({checked: false, merchant: m});
		}
		this.setState({listMerchantInfo: listMerchantInfo})
	}

	onMerchantChecked = (e, index) => {
		this.state.listMerchantInfo[index].checked = e.target.checked;
		this.setState({dirtyCounter: this.state.dirtyCounter + 1})
	}
	
	selectMerchants = () => {
		let listMerchant = [];
		for( let m of this.state.listMerchantInfo) {
			if( m.checked )
				listMerchant.push( m.merchant );
		}
		this.plain.selectMerchants( listMerchant );
		this.plain.closeSelectMerchantsModal();
	}
	
	render() {
		
		let tableRowsHtml = this.state.listMerchantInfo.map( (merchantInfo,index) => {
			let provider = '';
			if( merchantInfo.merchant.providerRef )
				provider = merchantInfo.merchant.providerRef.card;
			let acquirer = '';
			if( merchantInfo.merchant.acquirerRef )
				acquirer = merchantInfo.merchant.acquirerRef.card;
			return (
				<tr key={index}>
					<td><input type='checkbox' onChange={(e)=> {this.onMerchantChecked(e, index)} } 
						checked={this.state.listMerchantInfo[index].checked}/>
					</td>
					<td>{merchantInfo.merchant.mid}</td>
					<td>{provider}</td>
					<td>{acquirer}</td>
				</tr>
			);
		});
		return (
			<Modal 
				open={this.plain.state.isSelectMerchantsModalOpen} onClose={this.plain.closeSelectMerchantsModal} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				<div>
					<div style={localStyles.divHeader}>
						Вибрати мерчантів
					</div>
					<div style={{height: '300px', overflowY: 'auto', overflowX: 'hidden', margin: '20px' }}>
						<table border='1'>
						<thead style={{fontWeight: 'bold'}}>
							<tr>
								<td>&nbsp;</td><td>Код мерчанта</td><td>Постачальник</td><td>Еквайр</td>							
							</tr>
						</thead>
						<tbody>
							{tableRowsHtml}
						</tbody>
						</table>
					</div>
					<div style={{margin: '20px', textAlign: 'right'}}>
						<button type='button' style={{padding: '5px 20px 5px 20px'}} 
							onClick={this.selectMerchants}
						>Ok</button>
					</div>
				</div>
			</Modal>
			
		)
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '1200px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

const localStyles = {
	divHeader: {
		fontSize: '16pt',
		textAlign: 'center',
		padding: '10px',
		borderRadius: '21px 21px 0 0',
		backgroundColor: '#F0F0F0'
	},
	divParameters: {
		marginTop: '10px',
		padding: '10px'
	},
	divWaiting: {
		textAlign: 'center',
		padding: '7px'
	},
	divButtons: {
		marginTop: '7px',
		padding: '10px',
		marginRight: '15px',
		textAlign: 'right'
	}
};

export default SelectMerchantsModal;
